/**
 * Spinner — a loading indicator.
 *
 * `currentColor` means the ring inherits whatever text colour surrounds it, so
 * the same spinner looks right on a white page, inside a green button, or on a
 * dark background — without a colour prop.
 */

import { cn } from '@/lib/cn';

const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-9 w-9 border-[3px]',
};

export function Spinner({ size = 'md', className }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent',
        SIZES[size],
        className,
      )}
    />
  );
}

export default Spinner;
